import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/index';
import Title from './Title';

import livewellFinderBg from '../../images/livewellfinder-header-bg.png';

class Tabs extends Component
{
    constructor (props) {
        super(props);

        this.state = {
            selectedTab: 0
        };
    }

    changeTab = (value) => {
        this.setState({ selectedTab: value });
        this.props.onTabClick(value);
    }

    render () {
        const { onTabClick } = this.props;
        const { selectedTab } = this.state;

        return (
            <div className="content-layout content-layout__wide content-layout_collapse tabs-container" style={{ backgroundImage: `url(${livewellFinderBg})` }}>
                <Title />
                <div className="large-wrap justifycentre tabs-wrapper">
                    <div className="tabs">
                        <Button
                            classes={['tab-button', selectedTab === 0 && 'active'].join(' ')}
                            onClick={() => {
                                this.changeTab(0);
                            }}
                            label="I know what I’m looking for"
                        />
                        <Button
                            classes={['tab-button', selectedTab === 1 && 'active'].join(' ')}
                            onClick={() => {
                                this.changeTab(1);
                            }}
                            label="I want to explore"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Tabs.propTypes = {
    onTabClick: PropTypes.func,
};
  
Tabs.defaultProps = {
    onTabClick: () => {},
};


export default Tabs;
